import { call, put, takeLatest } from "redux-saga/effects";
import {
  doLoadingStart,
  doLoadingFinish,
} from "Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";

import * as actionTypes from "Redux/Actions/actionTypes";
import PlaidGetTokenRequest from "../../Communication/ApiClasses/PlaidGetTokenRequest";

// worker
function* handleGetPlaidToken(action) {
  yield put(doLoadingStart(`${actionTypes.GET_PLAID_TOKEN}_SAGA`));
  const plaidGetTokenApi = new PlaidGetTokenRequest(action.data);
  try {
    const result = yield call(plaidGetTokenApi.getData);
    yield call(action.callback, result);
  } catch (error) {
    yield call(action.callback, error.response);
  } finally {
    yield put(doLoadingFinish(`${actionTypes.GET_PLAID_TOKEN}_SAGA`));
  }
}

// watcher
export default function* getPlaidTokenWatcherSaga() {
  yield takeLatest(actionTypes.GET_PLAID_TOKEN, handleGetPlaidToken);
}
